// User-friendly authentication alerts
export const AUTH_MESSAGES = {
  WATCHLIST: {
    title: "🍿 Create Your Movie Collection!",
    message: "Sign up to build your personal watchlist and never forget what to watch next!",
    action: "Start Collecting"
  },
  REVIEW: {
    title: "⭐ Share Your Movie Thoughts!",
    message: "Join the conversation! Sign up to write reviews and help others discover great content.",
    action: "Join Discussion"
  },
  CHAT: {
    title: "💬 Connect with Movie Lovers!",
    message: "Sign up to chat with friends about your favorite movies and shows!",
    action: "Start Chatting"
  },
  FEED: {
    title: "🎬 Your Personal Movie Feed!",
    message: "Sign up to see what your friends are watching and share your own discoveries!",
    action: "Join Community"
  },
  LIKE: {
    title: "❤️ Show Some Love!",
    message: "Sign up to like posts and let others know what resonates with you!",
    action: "Spread Love"
  },
  FOLLOW: {
    title: "👥 Follow Your Favorites!",
    message: "Sign up to follow users and stay updated with their latest movie recommendations!",
    action: "Start Following"
  },
  PROFILE: {
    title: "🎭 Create Your Movie Profile!",
    message: "Sign up to showcase your movie taste and connect with like-minded film enthusiasts!",
    action: "Build Profile"
  },
  SEARCH: {
    title: "🔍 Discover More Content!",
    message: "Sign up to save your searches and get personalized movie recommendations!",
    action: "Unlock Discovery"
  },
  RATING: {
    title: "🌟 Rate Movies & Shows!",
    message: "Sign up to rate content and help build the ultimate movie recommendation engine!",
    action: "Start Rating"
  },
  COMMENT: {
    title: "💭 Join the Conversation!",
    message: "Sign up to comment on posts and engage with the movie community!",
    action: "Start Discussing"
  },
  REPORT: {
    title: "🚨 Help Improve Our Platform!",
    message: "Sign up to report issues and help us maintain high-quality content for everyone!",
    action: "Join Community"
  },
  ACHIEVEMENTS: {
    title: "🏆 Unlock Your Achievements!",
    message: "Sign up to track your progress, earn badges, and compete on leaderboards with fellow movie enthusiasts!",
    action: "Start Achieving"
  },
  BOOKMARKS: {
    title: "🔖 Save Your Favorite Posts!",
    message: "Sign up to bookmark posts and build your personal collection of interesting content!",
    action: "Start Bookmarking"
  },
  NEWS_BOOKMARKS: {
    title: "📰 Save News Articles!",
    message: "Sign up to bookmark news articles and never miss important updates about your favorite movies!",
    action: "Start Saving"
  },
  BLOCK_USER: {
    title: "🚫 Manage Your Experience!",
    message: "Sign up to block users and customize your social experience for better interactions!",
    action: "Take Control"
  }
};

export const getAuthMessage = (feature) => {
  return AUTH_MESSAGES[feature] || {
    title: "🎬 Join HypeCircle!",
    message: "Sign up to unlock all features and connect with movie lovers worldwide!",
    action: "Get Started"
  };
};

export const showAuthAlert = (addNotification, navigate, feature = 'DEFAULT') => {
  const { title, message, action } = getAuthMessage(feature);
  
  addNotification({
    type: 'info',
    message: `${title}\n${message}`,
    action: {
      label: action,
      onClick: () => navigate('/auth')
    },
    duration: 6000
  });
};